import merge from 'lodash-es/merge';
import buildColorsObject from './buildColorsObject';

/**
 * Esta función NO CALCULA ningún color, simplemente devuelve un objeto con las
 * rutas de color con el formato de ThemeUI. Es útil cuando se desea aplicar
 * colores definidos en el objeto colors.
 *
 * Si se desea generar un objeto con los colores a partir de una definición de
 * colores del tipo TGetColorStateDefinition se debe utilizar el método
 * getColorsByDefinition.
 */
export default function getColorsByPath(
  path: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: { mergeObject?: Record<string, any> },
) {
  return merge(
    buildColorsObject({
      color: `${path}.color`,
      backgroundColor: `${path}.backgroundColor`,
      borderColor: `${path}.borderColor`,
    }),
    options?.mergeObject,
  );
}
